import { Autocomplete, Chip, TextField } from '@mui/material';
import * as React from 'react';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { useAppSelector } from '../../../store/hooks';

interface Props {
    selectedOwner: string;
    guestList: string[];
    validationError: Record<string, string>;
    onSelectGuest: React.Dispatch<{ ddlGuestEmails: string[] }>;
}

export default function SelectContactsCalendarEvent({
    selectedOwner,
    guestList,
    validationError,
    onSelectGuest,
}: Props) {
    const users = useAppSelector(state => state.user?.users || []);

    const handleChange = (event: React.SyntheticEvent, newValue: string[]) => {
        onSelectGuest({ ddlGuestEmails: newValue });
    };

    const getLablel = (option: string) => {
        const user = users.find(user => user.email === option);
        if (user) {
            return `${user.firstName} ${user.lastName} - ${user.email}`;
        }
        return option;
    };

    const sortList = (a: UserInfo, b: UserInfo) => {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
    };

    return (
        <Autocomplete
            multiple
            id="tags"
            options={users
                .filter(user => user.userName !== selectedOwner)
                .sort(sortList)
                .map(user => user.email)}
            value={guestList}
            getOptionLabel={getLablel}
            freeSolo
            renderTags={(value: readonly string[], getTagProps) =>
                value
                    .filter(val => val !== selectedOwner)
                    .map((option: string, index: number) => (
                        <Chip label={option} {...getTagProps({ index })} />
                    ))
            }
            renderInput={params => (
                <TextField
                    {...params}
                    label="Add Attendees"
                    error={validationError.ddlGuestEmails ? true : false}
                    helperText={validationError.ddlGuestEmails || ''}
                />
            )}
            onChange={handleChange}
        />
    );
}
